import axios from 'axios';

export default {
  getCurrent: () => axios.get('/onboarding/current', { skipLoading: true }),
  trackEvent: (payload) => axios.post('/onboarding/events', payload, { skipLoading: true }),
};
